import { Box, Container, Text, Image, Stack, Heading, Avatar } from '@chakra-ui/react';
import { ReactElement, useEffect, useState } from 'react';
import Slider from 'components/logos-sliders';
import AppConsts from '../../libs/appconst';
import BannerService from '../../services/banners/banner-service';
import { useNavigate } from 'react-router-dom';
import AuthorService from '../../services/authors/author-service';
import ProgramService from '../../services/programs/program-service';


var settingSliderPopular = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                centerMode: true,
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                centerPadding: "3%"
            }
        },
        {
            breakpoint: 600,
            settings: {
                centerMode: true,
                slidesToShow: 1,
                speed: 4000,
                autoplaySpeed: 1000,
                slidesToScroll: 1,
                centerPadding: "4%"
            }
        }
    ]
};

const Program = (): ReactElement => {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [featuredPrograms, setFeaturedPrograms] = useState<any>([]);

    useEffect(() => {
        ProgramService.GetFeatured().then((res: any) => {
            setFeaturedPrograms(res.result);

            if (res.result.length < 4) {
                settingSliderPopular.slidesToShow = res.result.length;
            }
        });
    }, []);

    return (
        <Box bgColor='gray.50' py={24}>
            <Container maxWidth={"8xl"} >
                <Text fontSize={{ base: '2xl', md: '4xl' }} align={'center'} lineHeight={'normal'} fontWeight={"extrabold"} color={'blackAlpha.800'}>Populer Saat Ini</Text>
                <Text mb={12} fontSize={'md'} align={'center'}>Tingkatkan kualitas hidup Anda dengan pelatih dan program yang terbaik.</Text>

                <Slider height={'500px'} options={settingSliderPopular} arrows={false}>
                    {
                        featuredPrograms.map(({ id, name, description, posterUrl, author }: any) => {
                            return (
                                <Box
                                    key={id}
                                    px={1}
                                    cursor={"pointer"}
                                    onClick={() => navigate(`/checkout/${id}?utm_source=direct&utm_medium=webapp&utm_campaign=homepage`)}>
                                    <Box
                                        maxW={'445px'}
                                        w={'full'}
                                        //bg={useColorModeValue('white', 'gray.900')}
                                        bg={'white'}
                                        boxShadow={'md'}
                                        rounded={'md'}
                                        p={6}
                                        overflow={'hidden'}>
                                        <Box bg={'gray.100'} mt={-6} mx={-6} mb={4} pos={'relative'}>
                                            <Image src={posterUrl} />
                                        </Box>
                                        <Stack>
                                            <Heading
                                                //color={useColorModeValue('gray.700', 'white')}
                                                color={'gray.700'}
                                                fontSize={'lg'}
                                                fontFamily={'body'}>
                                                {name}
                                            </Heading>
                                            <Text color={'gray.500'} fontSize={'sm'} height={"125px"} noOfLines={[4, 5, 6]}>
                                                {description}
                                            </Text>
                                        </Stack>
                                        <Stack mt={6} direction={'row'} spacing={4} align={'center'}>
                                            <Avatar src={author.imageUrl} />
                                            <Stack direction={'column'} spacing={0} fontSize={'sm'}>
                                                <Text fontWeight={600}>{author.name}</Text>
                                                <Text color={'gray.500'}>{author.shortBioData}</Text>
                                            </Stack>
                                        </Stack>
                                    </Box>
                                </Box>
                            )
                        })
                    }
                </Slider>
            </Container>
        </Box>
    );
};

export default Program;